import { Injectable, signal, computed } from '@angular/core';
import { Notification } from '../models';

@Injectable({ providedIn: 'root' })
export class NotificationService {
  readonly notifications = signal<Notification[]>([]);

  readonly unreadCount = computed(
    () => this.notifications().filter(n => !n.read).length,
  );

  markAsRead(id: string): void {
    this.notifications.update(list =>
      list.map(n => (n.id === id ? { ...n, read: true } : n)),
    );
  }

  markAllAsRead(): void {
    this.notifications.update(list =>
      list.map(n => (n.read ? n : { ...n, read: true })),
    );
  }

  addNotification(notification: Notification): void {
    this.notifications.update(list => [notification, ...list]);
  }
}
